import { InitialFilter } from './InitialFiltersReducer';

const byCountry: (country: string) => (filter: InitialFilter) => boolean =
  (country: string) => (filter: InitialFilter) =>
    country === filter.country;

export { byCountry };
